// extracted by mini-css-extract-plugin
export var actions = "_id-g";
export var benefitCard = "_id-b";
export var benefitIcon = "_id-d";
export var benefitLabel = "_id-f";
export var benefits = "_id-a";
export var benefitsSection = "_id-8";
export var bodyText = "_id-7";
export var closeButton = "_id-2";
export var content = "_id-3";
export var eyebrow = "_id-4";
export var heading = "_id-5";
export var image = "_id-i";
export var imagePanel = "_id-h";
export var modal = "_id-0";
export var offerCard = "_id-c";
export var offerIcon = "_id-e";
export var sectionLabel = "_id-9";
export var shell = "_id-1";
export var title = "_id-6";